import Chart from "react-apexcharts";

const options: any = {
    xaxis: {
        // type: "datetime",
    },
    chart: {
        width: '100%',
        background: 'transparent',
        // toolbar: {
        //     show: false
        // }
    },
    theme: {
        mode: 'dark',
    }
};



export const CandleChart = ({ chart_list_series }: any) => {

    return (
        <>
            <div className="w-[98%] mx-auto" style={{ direction: "ltr" }}>
                <Chart
                    options={options}
                    series={[{ data: chart_list_series }]}
                    type="candlestick"
                    height={362}
                />
            </div>
        </>
    )
}